__turbopack_context__.v({
  "categoryCount": "WidgetsBoard-module-scss-module__yZdaCG__categoryCount",
  "categoryTitle": "WidgetsBoard-module-scss-module__yZdaCG__categoryTitle",
});
